import script from "./BarTextField.vue?vue&type=script&setup=true&lang=ts"
export * from "./BarTextField.vue?vue&type=script&setup=true&lang=ts"

import "./BarTextField.vue?vue&type=style&index=0&id=4cc28dca&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cc28dca"]])

export default __exports__